<template>
<div v-if="selectedPaymentMethod.includes('pix')">
  <div data-testid="div" class="emd-container">
    <div class="emd-container__header eu-py_4_md eu-px_5_md">
      <h2 class="emd-text _size_section _color_default">
        {{ $t('pix.payment.title') }}
      </h2>
    </div>
    <hr class="emd-divider">
    <div class="emd-container__content eu-pa_5_md">
      <emd-alert
        v-if="tabbarError.status"
        variant="danger"
        :title="$t('tabbarError')"
        @cancel="tabbarError.status = false"
        autoclose
      />
      <form action="">
        <div class="eu-flex eu-column eu-row_md">
          <div class="eu-flex-item eu-basis_4_md">
            <div class="emd-form-group">
              <label class="emd-label _required">{{ $t('pix.payment.dueDate') }}</label>
              <div class="emd-input-group">
                <input
                  v-mask="'##/##/####'"
                  v-model="pix.expires_at"
                  class="emd-input"
                  type="text"
                  placeholder="dd/mm/aaaa"
                  :class="{ '_state_error': !isValidDueDate && showFeedbacks.status }"
                  data-testid="input"
                />
              </div>
              <p class="emd-input-feedback _state_error" v-if="!isValidDueDate && showFeedbacks.status && !pix.expires_at.length">{{ $t('pix.payment.errors.required') }}</p>
              <p class="emd-input-feedback _state_error" v-if="!isValidDueDate && showFeedbacks.status && pix.expires_at.length">{{ $t('pix.payment.errors.dueDate', { date: setDatePlaceHolder }) }}</p>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="el-section">
    <div class="eu-display_flex eu-justify_space-between eu-wrap_reverse">
      <button class="emd-btn _color_secondary _type_text _block_mobile" @click="reverseRoute">
        <i class="uil uil-angle-left"></i>
        {{ $t('pix.payment.back') }}
      </button>
      <button class="emd-btn _color_secondary _block_mobile eu-mb_5 eu-no-margin_sm" @click="nextRoute">
        {{ $t('pix.payment.next') }}
        <i class="uil uil-angle-right"></i>
      </button>
    </div>
  </div>
</div>
</template>

<script>
import EmdAlert from '@/components/emerald/molecules/EmdAlert'
import { required } from 'vuelidate/lib/validators'
import { validateDate, setCurrentDate } from '@/utils/validations'

export default {
  name: 'PaymentPix',
  props: {
    selectedPaymentMethod: Array
  },
  components: {
    EmdAlert
  },
  computed: {
    pix () {
      return this.$store.getters.pix
    },
    isValidDueDate () {
      return !this.$v.pix.expires_at.$invalid
    },
    selectedPaymentType () {
      return this.$store.getters.selectedPaymentType
    },
    tabbarError () {
      return this.$store.getters.tabbarError
    },
    showFeedbacks () {
      return this.$store.getters.showFeedbacks
    },
    setDatePlaceHolder () {
      return setCurrentDate(0)
    }
  },
  validations: {
    pix: {
      expires_at: {
        required,
        validateDate
      }
    }
  },
  methods: {
    nextRoute () {
      if (this.isValidDueDate) {
        this.$router.push({ name: 'ReviewOrder' })
      } else {
        this.showFeedbacks.status = true
      }
    },
    reverseRoute () {
      this.$router.push({ name: 'Customer' })
    }
  },
  watch: {
    isValidDueDate: {
      handler: function () {
        this.$store.dispatch('SET_PERMISSION', {
          status: !this.isValidDueDate,
          component: this.$route.name,
          paymentType: this.selectedPaymentType
        })
        this.tabbarError.status = false
        this.showFeedbacks.status = false
      }
    }
  }
}
</script>
